// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as PorterStoreOrderEntityMapper from "../entity-mapper/PorterStoreOrderEntityMapper.bs.js";
import * as PorterStoreOrderDetailEntityMapper from "../entity-mapper/PorterStoreOrderDetailEntityMapper.bs.js";
import * as PorterStoreWalletStateEntityMapper from "../entity-mapper/PorterStoreWalletStateEntityMapper.bs.js";
import * as PorterStoreOrderProductsEntityMapper from "../entity-mapper/PorterStoreOrderProductsEntityMapper.bs.js";

var execute = PorterStoreOrderEntityMapper.execute;

var PorterStoreOrderListConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var PorterStoreOrderListResponseConverter = partial_arg(PorterStoreOrderListConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = PorterStoreOrderDetailEntityMapper.execute;

var PorterStoreOrderDetailConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var PorterStoreOrderDetailResponseConverter = partial_arg$1(PorterStoreOrderDetailConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = PorterStoreOrderProductsEntityMapper.execute;

var PorterStoreOrderProductsConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var PorterStoreOrderProductsResponseConverter = partial_arg$2(PorterStoreOrderProductsConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$3(_data) {
  
}

var PorterStorePaymentLinkConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var PorterStorePaymentLinkResponseConverter = partial_arg$3(PorterStorePaymentLinkConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$4 = PorterStoreWalletStateEntityMapper.execute;

var PorterStoreWalletStateConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var PorterStoreWalletStateResponseConverter = partial_arg$4(PorterStoreWalletStateConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$5(_data) {
  
}

var PorterStoreWalletPaymentConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var PorterStoreWalletPaymentResponseConverter = partial_arg$5(PorterStoreWalletPaymentConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  PorterStoreOrderListConfig ,
  PorterStoreOrderListResponseConverter ,
  PorterStoreOrderDetailConfig ,
  PorterStoreOrderDetailResponseConverter ,
  PorterStoreOrderProductsConfig ,
  PorterStoreOrderProductsResponseConverter ,
  PorterStorePaymentLinkConfig ,
  PorterStorePaymentLinkResponseConverter ,
  PorterStoreWalletStateConfig ,
  PorterStoreWalletStateResponseConverter ,
  PorterStoreWalletPaymentConfig ,
  PorterStoreWalletPaymentResponseConverter ,
  
}
/* PorterStoreOrderListResponseConverter Not a pure module */
